import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
} from '@mui/material'

import { Notification } from '../molecules'

interface ConfirmDialogProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>Подтвердить действие</DialogTitle>
      <DialogContent>
        <Notification
          message="Вы уверены, что хотите отклонить Акт? Изменения могут быть необратимы."
          type="info"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Нет</Button>
        <Button color="primary" variant="contained" onClick={onConfirm}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  )
}
